/* 主页 */
// const SearchBar = r => require.ensure([], () => r(require('@/components/SearchBar')))
const HomePage = r => require.ensure([], () => r(require('./')), 'HomePage')
const MainPage = r => require.ensure([], () => r(require('./config')), 'HomePage')
const HomePageSearch = r => require.ensure([], () => r(require('./search/')), 'HomePage')
const AddressSelectPage = r => require.ensure([], () => r(require('./address/')), 'HomePage')

export default {
  path:'/home',
  component: HomePage,
  meta: { title: '首页' },
  redirect: '/home/main',
  children: [{
    path: 'main',
    name: 'MainPage',
    meta: { title: '一键康' },
    component: MainPage
  },
  {
    path: 'search',
    name: 'AddressSelectPage',
    meta: { title: '搜索' },
    component: HomePageSearch
  },
  {
    path: 'address',
    name: 'HomePageSearch',
    meta: { title: '选择城市' },
    component: AddressSelectPage
  }]
}



// WEBPACK FOOTER //
// ./src/views/home/router.js